import React, {useEffect, useState} from 'react';
import AddDataModal from "./AddDataModal";
import EditDataModal from "./EditDataModal";
import Paginator from "../../components/common/Paginator/Paginator";
import HTMLReactParser from 'html-react-parser';
import { fileUrl } from "../../api/api";


const Blog = React.memo(({deleteBlogTh,blogs,...props}) => {

    // Preview URL-i təhlükəsiz qururuq: backend "abc.jpg" və ya "files/abc.jpg" qaytara bilər
    const buildPreviewUrl = (path) => {
        if (!path) return "";
        if (path.startsWith("http")) return path;
        const base = fileUrl.replace(/\/+$/, "");
        const normalized = path.replace(/^\/+/, "").startsWith("files/")
            ? path.replace(/^\/+/, "")
            : `files/${path.replace(/^\/+/, "")}`;
        return `${base}/${normalized}`;
    };
    let [isEditBlog, setIsEditBlog] =useState(false);
    let [isCreateBlog, setIsCreateBlog] =useState(false)
    let [blogId, setBlogId]=useState()
    const [show, setShow] = useState(false);

    useEffect((  )=>{
        if(isCreateBlog) setShow(isCreateBlog)
    },[isCreateBlog])

    useEffect((  )=>{
        if(isEditBlog) setShow(isEditBlog)
    },[isEditBlog])

    const EditBlog =(event)=>{
        debugger
        console.log(event.target.id)
        setBlogId(event.target.id)
        setIsEditBlog(true)
        // updateGroupTh(building)
    }

    const AddBlog=()=>
    {
        setIsCreateBlog(true);
    }


    let blogsList = blogs.map( blog =>
        <tr key={blog.id}>
            <td>{blog.id}</td>
            <td>
                {blog.imgUrl ?
                    <img
                        src={buildPreviewUrl(blog.imgUrl)}
                        alt={blog.title}
                        style={{maxHeight: "50px", maxWidth: "80px", borderRadius: "4px", objectFit: "cover"}}
                    /> :
                    <span className="text-muted">—</span>
                }
            </td>
            <td>{blog.title}</td>
            {/*<td>{HTMLReactParser(blog.content.substr(0,15))}</td>*/}
            {/*<td>{blog.imgUrl}</td>*/}
            {/*<td>{blog.youtubeLink}</td>*/}
            <td>{blog.status ===1 ?
                <span className="badge badge-pill badge-success">Active</span>
                :<span className="badge badge-pill badge-danger">Deactive</span>
            }</td>
            {/*<td>{blogType.filter(d=>d.id === parseInt(blog.blogType))[0].name }</td>*/}
            {/*<td>{blog.price}</td>*/}
            <td>{blog.created_at}</td>
            <td>
                <span className="badge bg-warning"
                      id={blog.id}
                      style={{cursor:"pointer"}}
                      onClick={EditBlog}>Redaktə</span>
            </td>
        </tr>
    )

    return (<div>
            {isCreateBlog &&
            <AddDataModal
                show={isCreateBlog}
                addBlogTh={props.addBlogTh}
                setIsCreateBlog={setIsCreateBlog}
                {...props}
            />}
            {isEditBlog &&
            <EditDataModal
                show={isEditBlog}
                setIsEditBlog={setIsEditBlog}
                blogId={blogId}
                blogs={blogs}
                updateBlogTh={props.updateBlogTh}
                deleteBlogTh={deleteBlogTh}
                {...props}
            />}
            <div className="card ml-1 mr-1 ">
                <div className="card-header">
                    <h3 className="card-title">Məhsul</h3>
                    <div className="card-tools">
                        <Paginator
                            totalElements={props.totalElements}
                            totalPages={props.totalPages}
                            size={props.size}
                            getNewPorsion={props.getBlogsTh}
                        />
                    </div>
                </div>
                <div className="card-body p-0">
                    <table className="table">
                        <thead>
                        <tr>
                            <th style={{width: "10px"}}>Id</th>
                            <th>Şəkil</th>
                            <th>Adı</th>
                            {/*<th>Kontent</th>*/}
                            {/*<th>imgUrl</th>*/}
                            {/*<th>youtubeLink</th>*/}
                            <th>status</th>
                            <th>Yaranma Tarixi</th>
                            <th style={{width: "40px"}}>
                                <span className="badge bg-info"
                                      style={{cursor:"pointer"}}
                                      onClick={AddBlog}>Əlavə Et</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {blogsList}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
});

export default Blog;
